import { Box } from '../Box';
import { Text } from '../Text';

type Props = {
  numberText: string | number;
  postfix?: string;
  useEllipsis?: boolean;
}

export const LegendNumber = ({ numberText, postfix, useEllipsis = true }: Props) => {
  return (
    <Box wrap="nowrap" a="flex-end" w="100px">
      <Text weight="light" ellipsis={useEllipsis} size="3xl">
        {numberText}
      </Text>
      <Text marginLeft="xs" marginBottom="xs" weight="normal" color="grey" size="sm">
        {postfix}
      </Text>
    </Box>
  );
};
